import { render } from "./ButtonDesigner.vue?vue&type=template&id=180dc73f"
import script from "./ButtonDesigner.vue?vue&type=script&lang=js"
export * from "./ButtonDesigner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__